<template>
    <div class="newdetail_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ data.title }}</div>
        </div>
        <div class="ctn">
            <!-- <vue-editor v-model="data.content" style="display: none"/> -->
            <div class="contract_box" v-html="data.content"></div>
        </div>
    </div>
</template>

<script>

import Fetch from "../../utils/fetch";
import bsHeader from '../../components/bsHeader.vue'

export default {
    name: "aritcle",
    components: {bsHeader},
    data() {
        return {
            data: {},
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.start();
    },
    methods: {
        start() {
            Fetch('/index/article_detail', {
                id: this.$router.history.current.params.code
            }).then(res => {
                this.data = res.data;
            })
        },
    }
};
</script>

<style lang="less" scoped>
.red_top_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgb(35, 29, 29) !important;
  color: rgb(239, 216, 196) !important;

  .back_left {
    color: rgb(239, 216, 196) !important;
  }

  .big_tit {
    color: rgb(239, 216, 196) !important;
  }
}

.ctn {
  height: calc(100vh - 44px);
  margin-top: 44px;
  overflow-y: scroll;background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
  padding: 5px;
  color: rgb(239, 216, 196) !important;
}

.newdetail_wrap {
  overflow-x: hidden;
  overflow-y: auto;
  background: #f5f5f5;
}


.contract_box {
  line-height: 20px;
}

.newdetail_wrap .ctn .title {
  font-size: 12px;
  color: #333;
  font-weight: bold;
  line-height: 1.7;
}

.newdetail_wrap .ctn .info {
  font-size: 12px;
  color: #333;
  line-height: 1.7;
}
</style>
